export default __webpack_public_path__ + "static/media/nos-clients.6b74b17b.jpg";